// extracted by mini-css-extract-plugin
export var modalFooter = "_pp-0";